import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';

// PWA 전용 출석 — 일반 attendance-reward.ts 와 1:1 동일한 static/repeat 보상 구조.
// is_active 토글 없음(운영 on/off 미사용), repeat 순환도 일반 출석과 동일.
// PWA 게이팅/검증은 클라(UI)에서만 — 서버 코덱/시드는 일반 출석과 완전 동일.
export const PwaAttendanceRewardSchema = defineSchema({
  name: 'serverPwaAttendanceRewards',
  fields: [
    [
      'static',
      { kind: 'array', of: { kind: 'record', value: { kind: 'dict', dict: 'delivery' } } },
    ],
    [
      'repeat',
      { kind: 'array', of: { kind: 'record', value: { kind: 'dict', dict: 'delivery' } } },
    ],
  ],
});

export interface RawPwaAttendanceRewardRow {
  static: unknown;
  repeat: unknown;
}

export function pwaAttendanceRewardFromRaw(row: RawPwaAttendanceRewardRow) {
  return { static: row.static, repeat: row.repeat };
}

registerCategorySchema('serverPwaAttendanceRewards', PwaAttendanceRewardSchema);
